import { useFormContext } from "react-hook-form";
import { Icon } from "@/react/components/shared/Icon";
import { classNames } from "@/react/helpers/twMergeWithCN";

type Visibility = "visible" | "hidden";

interface VisibilityFieldProps {
  label: string;
  name: string;
}

export const VisibilityField = ({ name, label }: VisibilityFieldProps) => {
  const { setValue, watch } = useFormContext();
  const value = watch(name) as Visibility;
  const isVisible = value === "visible";

  const handleToggleVisibility = () => {
    setValue(name, isVisible ? "hidden" : "visible");
  };

  return (
    <div className="flex flex-row items-center justify-between gap-4">
      <span className="text-dark text-xs font-semibold">{label}</span>
      <div className="bg-tertiary grid w-full grid-cols-2 gap-1 rounded-xl p-1">
        <button
          type="button"
          className={classNames("w-full rounded-lg px-2 py-1", {
            "bg-primary": isVisible,
            "bg-transparent": !isVisible,
          })}
          onClick={handleToggleVisibility}
        >
          <Icon type="20-visibility-visible" />
        </button>
        <button
          type="button"
          className={classNames("w-full rounded-lg px-2 py-1", {
            "bg-primary": !isVisible,
            "bg-transparent": isVisible,
          })}
          onClick={handleToggleVisibility}
        >
          <Icon type="20-visibility-hidden" />
        </button>
      </div>
    </div>
  );
};
